"use strict";
exports.__esModule = true;
require('./clipboard-copy.css');
exports.default = {
  "button": "pf-c-button",
  "clipboardCopy": "pf-c-clipboard-copy",
  "clipboardCopyActions": "pf-c-clipboard-copy__actions",
  "clipboardCopyActionsItem": "pf-c-clipboard-copy__actions-item",
  "clipboardCopyExpandableContent": "pf-c-clipboard-copy__expandable-content",
  "clipboardCopyGroup": "pf-c-clipboard-copy__group",
  "clipboardCopyText": "pf-c-clipboard-copy__text",
  "clipboardCopyToggleIcon": "pf-c-clipboard-copy__toggle-icon",
  "modifiers": {
    "expanded": "pf-m-expanded",
    "inline": "pf-m-inline",
    "block": "pf-m-block",
    "code": "pf-m-code"
  },
  "themeDark": "pf-theme-dark"
};